import { SET_LOYALTY } from 'actions/customers/loyalty/constants';

// FIXME The shape is incomplete. An entity store is blended in.
const initialState = {
  hasLoyalty: null,
};

function customAndDoNotEverDoThisInTheFutureReducer(
  state = initialState,
  action
) {
  // FIXME This is an entity store
  if (action.type === SET_LOYALTY) {
    return {
      ...state,
      ...action.payload,
    };
  }
  return state;
}

export default customAndDoNotEverDoThisInTheFutureReducer;
